import React from 'react';
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Globe, ChevronDown, Check } from "lucide-react";
import { useLanguage, Language } from "@/contexts/LanguageContext";

const languages = {
  es: { name: 'Español', code: 'ES' },
  en: { name: 'English', code: 'EN' },
  de: { name: 'Deutsch', code: 'DE' },
  nl: { name: 'Nederlands', code: 'NL' },
  fr: { name: 'Français', code: 'FR' }
};

const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();

  const handleLanguageChange = (langCode: Language) => {
    setLanguage(langCode);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="flex items-center space-x-2 text-enausa-gray hover:text-enausa-navy hover:bg-enausa-light/50 transition-all duration-200">
          <Globe className="w-4 h-4" />
          <span className="hidden sm:inline font-medium">{languages[language].name}</span>
          <span className="sm:hidden font-semibold text-xs bg-enausa-navy text-white px-2 py-1 rounded">{languages[language].code}</span>
          <ChevronDown className="w-3 h-3" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-background border border-border shadow-lg z-[60] min-w-[160px]">
        {Object.entries(languages).map(([langCode, langInfo]) => (
          <DropdownMenuItem
            key={langCode}
            onClick={() => handleLanguageChange(langCode as Language)}
            className={`flex items-center justify-between space-x-3 cursor-pointer hover:bg-muted focus:bg-muted px-3 py-2 transition-colors ${
              language === langCode ? 'bg-muted font-semibold' : ''
            }`}
          >
            <span className="font-medium">{langInfo.name}</span>
            <div className="flex items-center space-x-2">
              <span className="text-xs font-semibold text-enausa-gray bg-enausa-light px-2 py-1 rounded">{langInfo.code}</span>
              {language === langCode && <Check className="w-4 h-4 text-enausa-navy" />}
            </div>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSwitcher;